import ChapterWrapper from "../../../components/ChapterWrapper";
import ChapterIntro from "../../../components/ChapterIntro";
import ChapterLoading from "../../../components/Utils/ChapterLoading"
import { Helmet } from "react-helmet";
import { getChapterByID } from "playbook-pwa-ui/src/redux/modules/backendState";
import { useSelector } from "react-redux";
import Beratungsdialog from "../../../components/Beratungsdialog";
import BeratungPlanungMontage from "./sections/BeratungPlanungMontage";
import IndividuelleSchaumeinlagen from "./sections/IndividuelleSchaumeinlagen";
import VRAR from "./sections/VisualisierungMitVRundAR";
export default function DienstleistungspaketeFuerBetriebseinrichtung() {
  const chapterID = 10;
  const chapterData = useSelector((state) => getChapterByID(state, chapterID));

  if (!chapterData) {
    return <ChapterLoading />
  }

  const chapterBackground = chapterData.chapter.chapterImage.img;
  const chapterName = chapterData.chapter.name;

  return (
    <>
      <Helmet>
        <title>
          SSV-Kroschke Playbook | Dienstleistungspakete für Betriebseinrichtung
        </title>
      </Helmet>
      <Beratungsdialog />
      <ChapterWrapper chapterData={chapterData} chapterID={chapterID}>
        <ChapterIntro
          anchor="chapter-intro"
          background={chapterBackground}
          id={chapterID}
          name={chapterName}
        />
        <BeratungPlanungMontage anchor="beratung-planung-montage" />
        <IndividuelleSchaumeinlagen anchor="individuelle-schaumeinlagen" />
      </ChapterWrapper>
    </>
  );
}
